export const CHANGE_URL = 'change url';
export const ERROR_NOTIFICATION = 'errorNotification';
export const ERROR_POPUP = 'errorPopup';

export const URL_STATUSES = {
  complete: 'complete',
  loading: 'loading',
};
